import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { dropdownLink } from 'app/models/dropdownLink.interface';
import { SessionService } from 'app/services/session.service';
import { LocalStorageService } from 'app/services/localStorage.service';
import { AccountService } from 'app/services/account.service';
import { Subscription } from 'rxjs';
@Component({
  selector: 'user-account-dropdown',
  templateUrl: './user-account-dropdown.component.html',
  standalone: false,
})
export class UserAccountDropdownComponent implements OnInit, OnDestroy {
  @Input() title: string;
  @Input() subtitle: string;
  accountSubscription: Subscription;
  @Input() dropdownTo: dropdownLink[] = [
    {
      path: 'dashboard',
      title: 'Dashboard',
      icon: 'layout-dashboard',
    },
    {
      path: 'dashboard/myprofile',
      title: 'Settings',
      icon: 'settings',
    },
    {
      path: 'dashboard/logout',
      title: 'Log out',
      icon: 'log-out',
    },
  ];

  constructor(
    private sessionService: SessionService,
    private localStorageService: LocalStorageService,
    private accountService: AccountService
  ) {}

  ngOnInit() {
    let userInfo = null;
    const userStr = this.localStorageService.getItem('user');
    if (userStr) {
      try {
        userInfo = JSON.parse(userStr);
      } catch (e) {
        userInfo = null;
      }
    }
    if (userInfo && !userInfo['isDevhubUser']) {
      const dashboardIndex = this.dropdownTo.findIndex((item) => item.path === 'dashboard');
      if (dashboardIndex !== -1) {
        this.dropdownTo[dashboardIndex].path = 'legacy/dashboard'; // Update path for non-Devhub users
      }

      const userAccountIndex = this.dropdownTo.findIndex((item) => item.path === 'dashboard/myprofile');
      if (userAccountIndex !== -1) {
        this.dropdownTo[userAccountIndex].path = 'legacy/dashboard/account'; // Update path for non-Devhub users
      }

      const logoutIndex = this.dropdownTo.findIndex((item) => item.path === 'dashboard/logout');
      if (logoutIndex !== -1) {
        this.dropdownTo[logoutIndex].path = 'account/logout'; // Update path for non-Devhub users
      }
    }

    this.accountSubscription = this.accountService.accountInfo.subscribe((accountInfo: any) => {
      if (accountInfo && accountInfo['name'] && accountInfo['family_name']) {
        this.title = accountInfo['name'] + ' ' + accountInfo['family_name'];

        if (userInfo) {
          let updated = false;
          if (accountInfo['name']) {
            userInfo['firstName'] = accountInfo['name'];
            updated = true;
          }
          if (accountInfo['family_name']) {
            userInfo['lastName'] = accountInfo['family_name'];
            updated = true;
          }

          if (updated) {
            this.localStorageService.setItem('user', JSON.stringify(userInfo));
          }
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.accountSubscription) {
      this.accountSubscription.unsubscribe();
    }
  }

  signOut() {
    this.sessionService.logout();
  }
}
